import React, { useEffect, useState } from "react";
import {
  TextField,
  Checkbox,
  FormControlLabel,
  Typography,
  Button,
  CircularProgress,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from "@mui/material";
import "react-datepicker/dist/react-datepicker.css";
import TopTitleFormComponent from "./TopTitleFormComponent";
import { StandardDrawerFooter } from "./StandardDrawer";
import "./AdmissionDocumentRedesign.css";
import { doc, getDoc, setDoc, Timestamp } from "firebase/firestore";
import { db } from "../../firebase";
import { showCustomToast } from "../Misc/CustomToast";
import SubstanceAbuseTreatmentTable from "../Misc/SubstanceAbuseTreatementTable";
import dayjs from "dayjs";
import MentalHealthTreatmentTable from "../Misc/MentalHealthTreatmentTable";
import MedicalConditionsTable from "../Misc/MedicalConditionsTable";
import { Radio, RadioGroup } from "@mui/material";
import FamilyRelationshipsTable from "../Misc/FamilyRelationShipsTable";
import FamilyHistoryOfMentalHealthTable from "../Misc/FamilyHistoryOfMentalHealth";
import AddictionTreatmentTable from "../Misc/AddictionTreatmentTable";

const AddBioPsycho3 = (props) => {
  const [isSaving, setIsSaving] = useState(false);
  const [treatments, setTreatments] = useState([]);
  const [noPreviousTreatment, setNoPreviousTreatment] = useState(false);
  const [familyHistory, setFamilyHistory] = useState([]);
  const [mentalHealthTreatments, setMentalHealthTreatments] = useState([]);
  const [noPreviousMentalHealthTreatment, setNoPreviousMentalHealthTreatment] =
    useState(false);
  const [medicalConditions, setMedicalConditions] = useState([]);
  const [allergicToMedications, setAllergicToMedications] = useState(false);
  const [allergicMedicationsList, setAllergicMedicationsList] = useState("");
  const [hasPrimaryCarePhysician, setHasPrimaryCarePhysician] = useState(true);
  const [primaryPhysicianName, setPrimaryPhysicianName] = useState("");
  const [primaryPhysicianAddress, setPrimaryPhysicianAddress] = useState("");
  const [primaryPhysicianPhone, setPrimaryPhysicianPhone] = useState("");
  const [sexualAbuseHistory, setSexualAbuseHistory] = useState({
    hasBeenAbused: false,
    ageOfAbuse: "",
    byWhom: "",
    hasAbusedOthers: false,
    noHistory: false,
    currentConcern: false,
  });

  const [familyRelationships, setFamilyRelationships] = useState([]);

  const [familyWillingToParticipate, setFamilyWillingToParticipate] =
    useState("");

  const [summary, setSummary] = useState("");
  const [
    historyOfSubstanceAbuseProgression,
    setHistoryOfSubstanceAbuseProgression,
  ] = useState("");
  const [hasProcessAddiction, setHasProcessAddiction] = useState("no");
  const [processAddictionDetails, setProcessAddictionDetails] = useState("");
  const [motivationIntrinsicFactors, setMotivationIntrinsicFactors] =
    useState("");
  const [motivationExtrinsicFactors, setMotivationExtrinsicFactors] =
    useState("");
  const [mutualAidExperience, setMutualAidExperience] = useState("");
  const [pastSuicidalThoughts, setPastSuicidalThoughts] = useState("no");
  const [presentSuicidalThoughts, setPresentSuicidalThoughts] = useState("no");
  const [pastSuicideAttempts, setPastSuicideAttempts] = useState("no");
  const [presentSuicideAttempts, setPresentSuicideAttempts] = useState("no");
  const [pastSafetyPlanRequired, setPastSafetyPlanRequired] = useState("no");
  const [presentSafetyPlanRequired, setPresentSafetyPlanRequired] =
    useState("no");

  const [familyHistoryOfMentalHealth, setFamilyHistoryOfMentalHealth] =
    useState([]);
  const [whoRaisedClient, setWhoRaisedClient] = useState([]);
  const [whoRaisedClientOther, setWhoRaisedClientOther] = useState("");
  const [substanceUseInFamily, setSubstanceUseInFamily] = useState("no");
  const [substanceUseWho, setSubstanceUseWho] = useState("");
  const [impressionOfUpbringing, setImpressionOfUpbringing] = useState([]);
  const [currentHomeEnvironment, setCurrentHomeEnvironment] = useState("");
  const [socialSupportCurrentlyHave, setSocialSupportCurrentlyHave] =
    useState("");
  const [needForGriefTherapy, setNeedForGriefTherapy] = useState("no");
  const [experiencedTrauma, setExperiencedTrauma] = useState("no");
  const [natureOfTrauma, setNatureOfTrauma] = useState("");
  const [futureAssessmentRequired, setFutureAssessmentRequired] =
    useState("no");

  const [victimOfAbuse, setVictimOfAbuse] = useState([]);
  const [ageOfAbuse, setAgeOfAbuse] = useState("");
  const [byWhom, setByWhom] = useState("");

  const [relationshipWithFood, setRelationshipWithFood] = useState("");
  const [currentMobility, setCurrentMobility] = useState("");
  const [relationshipWithExercise, setRelationshipWithExercise] = useState("");
  const [goalsHealthFitness, setGoalsHealthFitness] = useState("no");
  const [goalsHealthFitnessDetails, setGoalsHealthFitnessDetails] =
    useState("");

  const [religiousGroups, setReligiousGroups] = useState([]);
  const [otherReligiousGroup, setOtherReligiousGroup] = useState("");
  const [strengths, setStrengths] = useState("");
  const [treatmentGoals, setTreatmentGoals] = useState("");
  const [natureOfTrauma2, setNatureOfTrauma2] = useState("");
  const [abuseDescription, setAbuseDescription] = useState("");
  const [addictionTreatments, setAddictionTreatments] = useState([]);
  const [noPreviousAddictionTreatment, setNoPreviousAddictionTreatment] =
    useState(false);

  // Handle Functions

  useEffect(() => {
    const loadBioPsychoData = async () => {
      if (props.clientId) {
        try {
          const docRef = doc(db, "bioPsychoSocialDigitalForm", props.clientId);
          const docSnap = await getDoc(docRef);

          if (docSnap.exists()) {
            const data = docSnap.data();
            // Exemple pour définir les états avec les données récupérées

            setTreatments(
              (data.substanceAbuseTreatment || []).map((treatment) => ({
                ...treatment,
                date:
                  treatment.date && treatment.date.toDate
                    ? dayjs(treatment.date.toDate())
                    : null, // Si aucune date valide, mettez null
              }))
            );
            setFamilyHistory(data.familyHistory || []);
            setNoPreviousTreatment(data.noPreviousTreatment || false);
            setAddictionTreatments(
              (data.addictionTreatments || []).map((treatment) => ({
                ...treatment,
                date:
                  treatment.date && treatment.date.toDate
                    ? dayjs(treatment.date.toDate())
                    : null,
              }))
            );
            setNoPreviousAddictionTreatment(
              data.noPreviousAddictionTreatment || false
            );

            setMentalHealthTreatments(
              (data.mentalHealthTreatments || []).map((treatment) => ({
                ...treatment,
                date:
                  treatment.date && treatment.date.toDate
                    ? dayjs(treatment.date.toDate())
                    : null,
              }))
            );
            setNoPreviousMentalHealthTreatment(
              data.noPreviousMentalHealthTreatment || false
            );
            setMedicalConditions(data.medicalConditions || []);
            setAllergicToMedications(data.allergicToMedications || false);
            setAllergicMedicationsList(data.allergicMedicationsList || "");
            setHasPrimaryCarePhysician(
              data.hasPrimaryCarePhysician !== undefined
                ? data.hasPrimaryCarePhysician
                : true
            );
            setPrimaryPhysicianName(data.primaryPhysicianName || "");
            setPrimaryPhysicianAddress(data.primaryPhysicianAddress || "");
            setPrimaryPhysicianPhone(data.primaryPhysicianPhone || "");
            setSexualAbuseHistory(
              data.sexualAbuseHistory || {
                hasBeenAbused: false,
                ageOfAbuse: "",
                byWhom: "",
                hasAbusedOthers: false,
                noHistory: false,
                currentConcern: false,
              }
            );
            setFamilyRelationships(data.familyRelationships || []);
            setFamilyWillingToParticipate(
              data.familyWillingToParticipate || ""
            );

            setSummary(data.summary || "");
            setHistoryOfSubstanceAbuseProgression(
              data.historyOfSubstanceAbuseProgression || ""
            );
            setHasProcessAddiction(data.hasProcessAddiction || "no");
            setProcessAddictionDetails(data.processAddictionDetails || "");
            setMotivationIntrinsicFactors(
              data.motivationIntrinsicFactors || ""
            );
            setMotivationExtrinsicFactors(
              data.motivationExtrinsicFactors || ""
            );
            setMutualAidExperience(data.mutualAidExperience || "");
            setPastSuicidalThoughts(data.pastSuicidalThoughts || "no");
            setPresentSuicidalThoughts(data.presentSuicidalThoughts || "no");
            setPastSuicideAttempts(data.pastSuicideAttempts || "no");
            setPresentSuicideAttempts(data.presentSuicideAttempts || "no");
            setPastSafetyPlanRequired(data.pastSafetyPlanRequired || "no");
            setPresentSafetyPlanRequired(
              data.presentSafetyPlanRequired || "no"
            );
            setFamilyHistoryOfMentalHealth(
              data.familyHistoryOfMentalHealth || []
            );
            setWhoRaisedClient(data.whoRaisedClient || []);
            setWhoRaisedClientOther(data.whoRaisedClientOther || "");
            setSubstanceUseInFamily(data.substanceUseInFamily || "no");
            setSubstanceUseWho(data.substanceUseWho || "");
            setImpressionOfUpbringing(data.impressionOfUpbringing || []);
            setCurrentHomeEnvironment(data.currentHomeEnvironment || "");
            setSocialSupportCurrentlyHave(
              data.socialSupportCurrentlyHave || ""
            );
            setNeedForGriefTherapy(data.needForGriefTherapy || "no");
            setExperiencedTrauma(data.experiencedTrauma || "no");
            setNatureOfTrauma(data.natureOfTrauma || "");
            setFutureAssessmentRequired(data.futureAssessmentRequired || "no");
            setVictimOfAbuse(data.victimOfAbuse || []);
            setAgeOfAbuse(data.ageOfAbuse || "");
            setByWhom(data.byWhom || "");
            setRelationshipWithFood(data.relationshipWithFood || "");
            setCurrentMobility(data.currentMobility || "");
            setRelationshipWithExercise(data.relationshipWithExercise || "");
            setGoalsHealthFitness(data.goalsHealthFitness || "no");
            setGoalsHealthFitnessDetails(data.goalsHealthFitnessDetails || "");
            setReligiousGroups(data.religiousGroups || []);
            setOtherReligiousGroup(data.otherReligiousGroup || "");
            setStrengths(data.strengths || "");
            setTreatmentGoals(data.treatmentGoals || "");
            setNatureOfTrauma2(data.natureOfTrauma2 || "");
            setAbuseDescription(data.abuseDescription || "");
          }
        } catch (error) {
          console.error("Error fetching BioPsycho data: ", error);
        }
      }
    };

    loadBioPsychoData();
  }, [props.clientId]); // Appelé uniquement lorsque clientId change



  console.log("addictionTreatments: ", addictionTreatments);

  const handleSave = async () => {
    try {
      const bioPsychoData = {
        noPreviousTreatment,
        addictionTreatments: addictionTreatments.map((treatment) => {
          if (treatment.date && !treatment.date.isValid()) {
            console.error(`Invalid date for addiction treatment:`, treatment);
            throw new Error("Invalid date value for addiction treatment");
          }
          return {
            ...treatment,
            date: treatment.date
              ? Timestamp.fromDate(treatment.date.toDate())
              : null,
          };
        }),
        noPreviousAddictionTreatment,
        substanceAbuseTreatment: treatments.map((treatment) => {
          if (treatment.date && !treatment.date.isValid()) {
            console.error(`Invalid date for treatment:`, treatment);
            throw new Error("Invalid date value");
          }
          return {
            ...treatment,
            date: treatment.date
              ? Timestamp.fromDate(treatment.date.toDate())
              : null,
          };
        }),
        familyHistory,
        mentalHealthTreatments: mentalHealthTreatments.map((treatment) => {
          if (treatment.date && !treatment.date.isValid()) {
            console.error(`Invalid date for treatment:`, treatment);
            throw new Error("Invalid date value");
          }
          return {
            ...treatment,
            date: treatment.date
              ? Timestamp.fromDate(treatment.date.toDate())
              : null,
          };
        }),
        noPreviousMentalHealthTreatment,
        medicalConditions,
        allergicToMedications,
        hasPrimaryCarePhysician,
        primaryPhysicianName,
        primaryPhysicianAddress,
        primaryPhysicianPhone,
        allergicMedicationsList,
        sexualAbuseHistory,
        familyRelationships,
        familyWillingToParticipate,
        summary,
        historyOfSubstanceAbuseProgression,
        hasProcessAddiction,
        processAddictionDetails,
        motivationIntrinsicFactors,
        motivationExtrinsicFactors,
        mutualAidExperience,
        pastSuicidalThoughts,
        presentSuicidalThoughts,
        pastSuicideAttempts,
        presentSuicideAttempts,
        pastSafetyPlanRequired,
        presentSafetyPlanRequired,
        familyHistoryOfMentalHealth,
        whoRaisedClient,
        whoRaisedClientOther,
        substanceUseInFamily,
        substanceUseWho,
        impressionOfUpbringing,
        currentHomeEnvironment,
        socialSupportCurrentlyHave,
        needForGriefTherapy,
        experiencedTrauma,
        natureOfTrauma,
        futureAssessmentRequired,
        victimOfAbuse,
        ageOfAbuse,
        byWhom,
        relationshipWithFood,
        currentMobility,
        relationshipWithExercise,
        goalsHealthFitness,
        goalsHealthFitnessDetails,
        religiousGroups,
        otherReligiousGroup,
        strengths,
        treatmentGoals,
        natureOfTrauma2,
        abuseDescription,
      };

      const docRef = doc(db, "bioPsychoSocialDigitalForm", props.clientId);
      await setDoc(docRef, bioPsychoData, { merge: true });

      showCustomToast("Data successfully saved!", "success");
      setIsSaving(false); // Désactiver l'état de chargement
      props.closemodal(); // Fermer le modal
    } catch (error) {
      console.error("Error saving BioPsycho data: ", error);
      showCustomToast("Error saving data, please try again.", "error");
      setIsSaving(false);
    }
  };

  return (
    <div
      className="admission-document-shell admission-card-form-shell biopsychosocial-form-shell"
    >
      <div className="line1-modal-percent">
        <TopTitleFormComponent
          eyebrow="Clinical form"
          title="Biopsychosocial assessment"
          subtitle={`${props.firstName || ""} ${props.lastName || ""}`.trim() || "Client"}
          closemodal={props.closemodal}
        />
      </div>
      <div
        className="admission-document-body"
        style={{
          width: "100%",
          overflowX: "hidden",
        }}
      >
        <Typography variant="h6" gutterBottom>
          History of Substance Abuse Treatment:
        </Typography>

        <div className="block-style2">
          <Typography
            // variant="h6"
            style={{ marginTop: "10px", marginBottom: "0px", fontSize: "16px" }}
          >
            History of substance abuse and progression
          </Typography>
          <TextField
            label="History of substance abuse and progression"
            multiline
            rows={4}
            value={historyOfSubstanceAbuseProgression}
            onChange={(e) =>
              setHistoryOfSubstanceAbuseProgression(e.target.value)
            }
            fullWidth
            variant="outlined"
            margin="normal"
          />

          <Typography
            style={{ marginTop: "20px", marginBottom: "0px", fontSize: "16px" }}
          >
            Motivation for change
          </Typography>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              gap: "10px",
              marginTop: "0px",
            }}
          >
            <TextField
              label="Intrinsic factors"
              multiline
              rows={4}
              value={motivationIntrinsicFactors}
              onChange={(e) => setMotivationIntrinsicFactors(e.target.value)}
              fullWidth
              variant="outlined"
              margin="normal"
            />
            <TextField
              label="Extrinsic factors"
              multiline
              rows={4}
              value={motivationExtrinsicFactors}
              onChange={(e) => setMotivationExtrinsicFactors(e.target.value)}
              fullWidth
              variant="outlined"
              margin="normal"
            />
          </div>

          <Typography
            style={{
              marginTop: "10px",
              marginBottom: "0px",
              fontSize: "16px",
            }}
          >
            Any history of process addicton (Sex, porn, Food, Work)?
          </Typography>
          <RadioGroup
            row
            value={hasProcessAddiction}
            onChange={(e) => setHasProcessAddiction(e.target.value)}
          >
            <FormControlLabel value="yes" control={<Radio />} label="Yes" />
            <FormControlLabel value="no" control={<Radio />} label="No" />
          </RadioGroup>
          {hasProcessAddiction === "yes" && (
            <TextField
              label="Please describe"
              multiline
              rows={4}
              value={processAddictionDetails}
              onChange={(e) => setProcessAddictionDetails(e.target.value)}
              fullWidth
              variant="outlined"
              margin="normal"
            />
          )}

          <div style={{ paddingTop: "25px" }}>
            <SubstanceAbuseTreatmentTable
              treatments={treatments}
              setTreatments={setTreatments}
              noPreviousTreatment={noPreviousTreatment}
              setNoPreviousTreatment={setNoPreviousTreatment}
            />
          </div>

          {/* <FamilyHistoryTable
          familyHistory={familyHistory}
          setFamilyHistory={setFamilyHistory}
        /> */}
          <div style={{ marginTop: "40px" }}>
            <MentalHealthTreatmentTable
              treatments={mentalHealthTreatments}
              setTreatments={setMentalHealthTreatments}
              noPreviousTreatment={noPreviousMentalHealthTreatment}
              setNoPreviousTreatment={setNoPreviousMentalHealthTreatment}
            />
          </div>
          <div style={{ marginTop: "40px" }}>
            <AddictionTreatmentTable
              treatments={addictionTreatments}
              setTreatments={setAddictionTreatments}
              noPreviousTreatment={noPreviousAddictionTreatment}
              setNoPreviousTreatment={setNoPreviousAddictionTreatment}
            />
          </div>
        </div>

        <Typography variant="h6" style={{ marginTop: "20px" }}>
          Mutual Aid and 12 Steps support
        </Typography>

        <div className="block-style2">
          <Typography
            style={{ marginTop: "10px", marginBottom: "0px", fontSize: "16px" }}
          >
            Have you ever had any experiences of Mutual Aid and / or 12 steps
            fellowships?
          </Typography>
          <TextField
            multiline
            rows={4}
            value={mutualAidExperience}
            onChange={(e) => setMutualAidExperience(e.target.value)}
            fullWidth
            variant="outlined"
            margin="normal"
          />
        </div>

        <Typography
          variant="h6"
          style={{ marginTop: "20px", marginBottom: "20px" }}
        >
          Medical Conditions and Medications
        </Typography>
        <div className="block-style2">
          <MedicalConditionsTable
            medicalConditions={medicalConditions}
            setMedicalConditions={setMedicalConditions}
          />

          <Typography>Allergic to any medications?</Typography>
          <RadioGroup
            row
            value={allergicToMedications}
            onChange={(e) => setAllergicToMedications(e.target.value)}
          >
            <FormControlLabel value="yes" control={<Radio />} label="Yes" />
            <FormControlLabel value="no" control={<Radio />} label="No" />
          </RadioGroup>
          {allergicToMedications && (
            <div style={{ width: "30%" }}>
              <TextField
                label="What medication(s)?"
                value={allergicMedicationsList}
                onChange={(e) => setAllergicMedicationsList(e.target.value)}
                fullWidth
                margin="normal"
              />
            </div>
          )}
        </div>

        <Typography variant="h6" style={{ marginTop: "20px" }}>
          Suicide/Homicide Assessment
        </Typography>

        <div className="block-style2">
          <Table style={{ marginTop: "10px" }}>
            <TableHead>
              <TableRow>
                <TableCell>Client has</TableCell>
                <TableCell>Past</TableCell>
                <TableCell>Present</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <TableCell>Suicidal Thoughts</TableCell>
                <TableCell>
                  <RadioGroup
                    row
                    value={pastSuicidalThoughts}
                    onChange={(e) => setPastSuicidalThoughts(e.target.value)}
                  >
                    <FormControlLabel
                      value="yes"
                      control={<Radio />}
                      label="Yes"
                    />
                    <FormControlLabel
                      value="no"
                      control={<Radio />}
                      label="No"
                    />
                  </RadioGroup>
                </TableCell>
                <TableCell>
                  <RadioGroup
                    row
                    value={presentSuicidalThoughts}
                    onChange={(e) => setPresentSuicidalThoughts(e.target.value)}
                  >
                    <FormControlLabel
                      value="yes"
                      control={<Radio />}
                      label="Yes"
                    />
                    <FormControlLabel
                      value="no"
                      control={<Radio />}
                      label="No"
                    />
                  </RadioGroup>
                </TableCell>
              </TableRow>

              <TableRow>
                <TableCell>Prior suicide attempts</TableCell>
                <TableCell>
                  <RadioGroup
                    row
                    value={pastSuicideAttempts}
                    onChange={(e) => setPastSuicideAttempts(e.target.value)}
                  >
                    <FormControlLabel
                      value="yes"
                      control={<Radio />}
                      label="Yes"
                    />
                    <FormControlLabel
                      value="no"
                      control={<Radio />}
                      label="No"
                    />
                  </RadioGroup>
                </TableCell>
                <TableCell>
                  <RadioGroup
                    row
                    value={presentSuicideAttempts}
                    onChange={(e) => setPresentSuicideAttempts(e.target.value)}
                  >
                    <FormControlLabel
                      value="yes"
                      control={<Radio />}
                      label="Yes"
                    />
                    <FormControlLabel
                      value="no"
                      control={<Radio />}
                      label="No"
                    />
                  </RadioGroup>
                </TableCell>
              </TableRow>

              <TableRow>
                <TableCell>Safety plan required</TableCell>
                <TableCell>
                  <RadioGroup
                    row
                    value={pastSafetyPlanRequired}
                    onChange={(e) => setPastSafetyPlanRequired(e.target.value)}
                  >
                    <FormControlLabel
                      value="yes"
                      control={<Radio />}
                      label="Yes"
                    />
                    <FormControlLabel
                      value="no"
                      control={<Radio />}
                      label="No"
                    />
                  </RadioGroup>
                </TableCell>
                <TableCell>
                  <RadioGroup
                    row
                    value={presentSafetyPlanRequired}
                    onChange={(e) =>
                      setPresentSafetyPlanRequired(e.target.value)
                    }
                  >
                    <FormControlLabel
                      value="yes"
                      control={<Radio />}
                      label="Yes"
                    />
                    <FormControlLabel
                      value="no"
                      control={<Radio />}
                      label="No"
                    />
                  </RadioGroup>
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </div>

        <Typography variant="h6" style={{ marginTop: "20px" }}>
          Family History of Mental Health
        </Typography>

        <div className="block-style2">
          <FamilyHistoryOfMentalHealthTable
            familyHistoryOfMentalHealth={familyHistoryOfMentalHealth}
            setFamilyHistoryOfMentalHealth={setFamilyHistoryOfMentalHealth}
          />

          <Typography style={{ marginTop: "20px", fontSize: "16px" }}>
            Family of origin : (What happened while growing up - check all that
            apply)
          </Typography>

          <div className="block-style2">
            <div style={{ marginTop: "10px" }}>
              <Typography style={{ fontSize: "16px", marginBottom: "5px" }}>
                Who raised client ?
              </Typography>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={whoRaisedClient.includes("Mother")}
                    onChange={(e) => {
                      const checked = e.target.checked;
                      setWhoRaisedClient((prev) =>
                        checked
                          ? [...prev, "Mother"]
                          : prev.filter((item) => item !== "Mother")
                      );
                    }}
                  />
                }
                label="Mother"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={whoRaisedClient.includes("Father")}
                    onChange={(e) => {
                      const checked = e.target.checked;
                      setWhoRaisedClient((prev) =>
                        checked
                          ? [...prev, "Father"]
                          : prev.filter((item) => item !== "Father")
                      );
                    }}
                  />
                }
                label="Father"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={whoRaisedClient.includes("Grandparent")}
                    onChange={(e) => {
                      const checked = e.target.checked;
                      setWhoRaisedClient((prev) =>
                        checked
                          ? [...prev, "Grandparent"]
                          : prev.filter((item) => item !== "Grandparent")
                      );
                    }}
                  />
                }
                label="Grandparent"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={whoRaisedClient.includes("Other")}
                    onChange={(e) => {
                      const checked = e.target.checked;
                      setWhoRaisedClient((prev) =>
                        checked
                          ? [...prev, "Other"]
                          : prev.filter((item) => item !== "Other")
                      );
                    }}
                  />
                }
                label="Other"
              />
              {whoRaisedClient.includes("Other") && (
                <div style={{ marginTop: "5px" }}>
                  <TextField
                    placeholder="Specify other"
                    value={whoRaisedClientOther}
                    onChange={(e) => setWhoRaisedClientOther(e.target.value)}
                    style={{ width: "200px" }}
                  />
                </div>
              )}
            </div>

            <div style={{ marginTop: "20px" }}>
              <Typography style={{ fontSize: "16px", marginBottom: "5px" }}>
                Substance use in the family?
              </Typography>
              <RadioGroup
                row
                value={substanceUseInFamily}
                onChange={(e) => setSubstanceUseInFamily(e.target.value)}
              >
                <FormControlLabel value="yes" control={<Radio />} label="Yes" />
                <FormControlLabel value="no" control={<Radio />} label="No" />
              </RadioGroup>
              {substanceUseInFamily === "yes" && (
                <div style={{ marginTop: "5px" }}>
                  <Typography style={{ fontSize: "16px", marginBottom: "5px" }}>
                    Who?
                  </Typography>
                  <TextField
                    placeholder="Who?"
                    value={substanceUseWho}
                    onChange={(e) => setSubstanceUseWho(e.target.value)}
                    style={{ width: "200px" }}
                  />
                </div>
              )}
            </div>

            <div style={{ marginTop: "20px" }}>
              <Typography style={{ fontSize: "16px", marginBottom: "5px" }}>
                Therapist impression of upbringing
              </Typography>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={impressionOfUpbringing.includes("Healthy")}
                    onChange={(e) => {
                      const checked = e.target.checked;
                      setImpressionOfUpbringing((prev) =>
                        checked
                          ? [...prev, "Healthy"]
                          : prev.filter((item) => item !== "Healthy")
                      );
                    }}
                  />
                }
                label="Healthy"
              />

              <FormControlLabel
                control={
                  <Checkbox
                    checked={impressionOfUpbringing.includes("Fair")}
                    onChange={(e) => {
                      const checked = e.target.checked;
                      setImpressionOfUpbringing((prev) =>
                        checked
                          ? [...prev, "Fair"]
                          : prev.filter((item) => item !== "Fair")
                      );
                    }}
                  />
                }
                label="Fair"
              />

              <FormControlLabel
                control={
                  <Checkbox
                    checked={impressionOfUpbringing.includes("Dysfunctional")}
                    onChange={(e) => {
                      const checked = e.target.checked;
                      setImpressionOfUpbringing((prev) =>
                        checked
                          ? [...prev, "Dysfunctional"]
                          : prev.filter((item) => item !== "Dysfunctional")
                      );
                    }}
                  />
                }
                label="Dysfunctional"
              />
            </div>
          </div>
        </div>

        <Typography variant="h6" style={{ marginTop: "20px" }}>
          Current Family Relationships
        </Typography>

        <div className="block-style2">
          {/* <Typography variant="h6">Family Relationships</Typography> */}
          <FamilyRelationshipsTable
            relationships={familyRelationships}
            setRelationships={setFamilyRelationships}
          />
        </div>

        <div className="block-style2">
          <Typography
            style={{ marginTop: "20px", marginBottom: "0px", fontSize: "16px" }}
          >
            Describe current home environment (include description of location
            to determine suitability)
          </Typography>
          <TextField
            multiline
            rows={4}
            value={currentHomeEnvironment}
            onChange={(e) => setCurrentHomeEnvironment(e.target.value)}
            fullWidth
            variant="outlined"
            margin="normal"
          />
        </div>

        <div className="block-style2">
          <Typography
            style={{ marginTop: "20px", marginBottom: "0px", fontSize: "16px" }}
          >
            Describe social support you currently have at this time
          </Typography>
          <TextField
            multiline
            rows={4}
            value={socialSupportCurrentlyHave}
            onChange={(e) => setSocialSupportCurrentlyHave(e.target.value)}
            fullWidth
            variant="outlined"
            margin="normal"
          />
        </div>

        <div className="block-style2">
          <Typography
            style={{
              marginTop: "20px",
              marginBottom: "10px",
              fontSize: "16px",
            }}
          >
            Is there a presenting need for grief therapy?
          </Typography>
          <RadioGroup
            row
            value={needForGriefTherapy}
            onChange={(e) => setNeedForGriefTherapy(e.target.value)}
          >
            <FormControlLabel value="yes" control={<Radio />} label="Yes" />
            <FormControlLabel value="no" control={<Radio />} label="No" />
          </RadioGroup>
        </div>

        <div className="block-style2">
          <Typography
            style={{
              marginTop: "20px",
              marginBottom: "10px",
              fontSize: "16px",
            }}
          >
            Have you ever experienced trauma?
          </Typography>
          <RadioGroup
            row
            value={experiencedTrauma}
            onChange={(e) => setExperiencedTrauma(e.target.value)}
          >
            <FormControlLabel value="yes" control={<Radio />} label="Yes" />
            <FormControlLabel value="no" control={<Radio />} label="No" />
          </RadioGroup>
          {experiencedTrauma === "yes" && (
            <div style={{ marginTop: "10px" }}>
              <Typography style={{ fontSize: "16px", marginBottom: "5px" }}>
                Please describe the trauma
              </Typography>
              <TextField
                multiline
                rows={4}
                fullWidth
                variant="outlined"
                value={natureOfTrauma2}
                onChange={(e) => setNatureOfTrauma2(e.target.value)}
              />
            </div>
          )}

          {/* {experiencedTrauma === "yes" && (
            <>
              <Typography
                style={{
                  marginTop: "20px",
                  marginBottom: "0px",
                  fontSize: "16px",
                }}
              >
                Nature of Trauma
              </Typography>
              <TextField
                multiline
                rows={4}
                value={natureOfTrauma}
                onChange={(e) => setNatureOfTrauma(e.target.value)}
                fullWidth
                variant="outlined"
                margin="normal"
              />
            </>
          )} */}

          <Typography
            style={{
              marginTop: "20px",
              marginBottom: "10px",
              fontSize: "16px",
            }}
          >
            Future assessment required?
          </Typography>
          <RadioGroup
            row
            value={futureAssessmentRequired}
            onChange={(e) => setFutureAssessmentRequired(e.target.value)}
          >
            <FormControlLabel value="yes" control={<Radio />} label="Yes" />
            <FormControlLabel value="no" control={<Radio />} label="No" />
          </RadioGroup>

          <Typography
            style={{ fontSize: "16px", marginTop: "20px", marginBottom: "5px" }}
          >
            Have you ever been victim of abuse?
          </Typography>
          <FormControlLabel
            control={
              <Checkbox
                checked={victimOfAbuse.includes("Physical")}
                onChange={(e) => {
                  const checked = e.target.checked;
                  setVictimOfAbuse((prev) =>
                    checked
                      ? [...prev, "Physical"]
                      : prev.filter((item) => item !== "Physical")
                  );
                }}
              />
            }
            label="Physical"
          />

          <FormControlLabel
            control={
              <Checkbox
                checked={victimOfAbuse.includes("Emotional")}
                onChange={(e) => {
                  const checked = e.target.checked;
                  setVictimOfAbuse((prev) =>
                    checked
                      ? [...prev, "Emotional"]
                      : prev.filter((item) => item !== "Emotional")
                  );
                }}
              />
            }
            label="Emotional"
          />

          <FormControlLabel
            control={
              <Checkbox
                checked={victimOfAbuse.includes("Mental")}
                onChange={(e) => {
                  const checked = e.target.checked;
                  setVictimOfAbuse((prev) =>
                    checked
                      ? [...prev, "Mental"]
                      : prev.filter((item) => item !== "Mental")
                  );
                }}
              />
            }
            label="Mental"
          />

          <FormControlLabel
            control={
              <Checkbox
                checked={victimOfAbuse.includes("Sexual abuse")}
                onChange={(e) => {
                  const checked = e.target.checked;
                  setVictimOfAbuse((prev) =>
                    checked
                      ? [...prev, "Sexual abuse"]
                      : prev.filter((item) => item !== "Sexual abuse")
                  );
                }}
              />
            }
            label="Sexual abuse"
          />

          {victimOfAbuse.includes("Sexual abuse") && (
            <div style={{ marginTop: "10px" }}>
              <TextField
                label="Age of Abuse"
                value={ageOfAbuse}
                onChange={(e) => setAgeOfAbuse(e.target.value)}
                style={{ marginRight: "10px", width: "200px" }}
                variant="outlined"
                size="small"
              />
              <TextField
                label="By Whom"
                value={byWhom}
                onChange={(e) => setByWhom(e.target.value)}
                style={{ width: "200px" }}
                variant="outlined"
                size="small"
              />
            </div>
          )}

          <div style={{ marginTop: "20px" }}>
            <Typography style={{ fontSize: "16px", marginBottom: "5px" }}>
              Describe your abuse
            </Typography>
            <TextField
              multiline
              rows={4}
              fullWidth
              variant="outlined"
              value={abuseDescription}
              onChange={(e) => setAbuseDescription(e.target.value)}
            />
          </div>
        </div>

        <div className="block-style2">
          <div style={{ marginTop: "20px" }}>
            <Typography style={{ fontSize: "16px", marginBottom: "5px" }}>
              Describe your relationship with food
            </Typography>
            <TextField
              multiline
              rows={4}
              fullWidth
              variant="outlined"
              value={relationshipWithFood}
              onChange={(e) => setRelationshipWithFood(e.target.value)}
            />
          </div>
        </div>

        <Typography variant="h6" style={{ marginTop: "20px" }}>
          Health and Fitness
        </Typography>

        <div className="block-style2">
          <div style={{ marginTop: "10px" }}>
            <Typography style={{ fontSize: "16px", marginBottom: "5px" }}>
              Describe your current mobility, level of fitness, physical
              exercise and self-care
            </Typography>
            <TextField
              multiline
              rows={4}
              fullWidth
              variant="outlined"
              value={currentMobility}
              onChange={(e) => setCurrentMobility(e.target.value)}
            />
          </div>

          <div style={{ marginTop: "20px" }}>
            <Typography style={{ fontSize: "16px", marginBottom: "5px" }}>
              What is your relationship with exercise?
            </Typography>
            <TextField
              multiline
              rows={4}
              fullWidth
              variant="outlined"
              value={relationshipWithExercise}
              onChange={(e) => setRelationshipWithExercise(e.target.value)}
            />
          </div>

          <div style={{ marginTop: "20px" }}>
            <Typography style={{ fontSize: "16px", marginBottom: "5px" }}>
              Have you any goals relating to your health and fitness that we can
              support you in?
            </Typography>
            <RadioGroup
              row
              value={goalsHealthFitness}
              onChange={(e) => setGoalsHealthFitness(e.target.value)}
            >
              <FormControlLabel value="yes" control={<Radio />} label="Yes" />
              <FormControlLabel value="no" control={<Radio />} label="No" />
            </RadioGroup>
            {goalsHealthFitness === "yes" && (
              <div style={{ marginTop: "10px" }}>
                <TextField
                  multiline
                  rows={4}
                  fullWidth
                  variant="outlined"
                  value={goalsHealthFitnessDetails}
                  onChange={(e) => setGoalsHealthFitnessDetails(e.target.value)}
                />
              </div>
            )}
          </div>
        </div>

        <Typography variant="h6" style={{ marginTop: "20px" }}>
          Religion / Spirituality
        </Typography>
        <div className="block-style2">
          {[
            "None",
            "Baptist",
            "Lutheran",
            "Protestant",
            "Jewish",
            "Catholic",
            "Muslim",
            "Non-denominational",
            "Jehova witness",
            "other",
          ].map((option) => (
            <FormControlLabel
              key={option}
              control={
                <Checkbox
                  checked={religiousGroups.includes(option)}
                  onChange={(e) => {
                    const checked = e.target.checked;
                    setReligiousGroups((prev) =>
                      checked
                        ? [...prev, option]
                        : prev.filter((item) => item !== option)
                    );
                  }}
                />
              }
              label={option}
            />
          ))}

          {religiousGroups.includes("other") && (
            <div style={{ marginTop: "10px" }}>
              <TextField
                placeholder="Specify other"
                value={otherReligiousGroup}
                onChange={(e) => setOtherReligiousGroup(e.target.value)}
                style={{ width: "200px" }}
                variant="outlined"
                size="small"
              />
            </div>
          )}

          <div style={{ marginTop: "20px" }}>
            <Typography style={{ fontSize: "16px", marginBottom: "5px" }}>
              What would you say your strengths are?
            </Typography>
            <TextField
              multiline
              rows={4}
              fullWidth
              variant="outlined"
              value={strengths}
              onChange={(e) => setStrengths(e.target.value)}
            />
          </div>

          <div style={{ marginTop: "20px" }}>
            <Typography style={{ fontSize: "16px", marginBottom: "5px" }}>
              What are your Treatment Goals? What do you want to achieve during
              your time here?
            </Typography>
            <TextField
              multiline
              rows={4}
              fullWidth
              variant="outlined"
              value={treatmentGoals}
              onChange={(e) => setTreatmentGoals(e.target.value)}
            />
          </div>
        </div>

        {/* Identify family willing to participate */}
        <div className="block-style2">
          <Typography>
            Identify family that would be willing to participate in treatment to
            assist client in recovery:
          </Typography>
          <TextField
            value={familyWillingToParticipate}
            onChange={(e) => setFamilyWillingToParticipate(e.target.value)}
            fullWidth
            margin="normal"
            multiline
            rows={4}
            variant="outlined"
          />
        </div>

        {/* Summary Block */}
        <div className="block-style2">
          <Typography>Summary of Presenting Problems and Needs:</Typography>
          <div>
            <TextField
              value={summary}
              onChange={(e) => setSummary(e.target.value)}
              fullWidth
              margin="normal"
              multiline
              rows={4}
              variant="outlined"
            />
          </div>
        </div>
      </div>
      <StandardDrawerFooter className="admission-document-footer">
        <Button
          variant="contained"
          style={{ backgroundColor: "white", color: "black" }}
          // disabled={!(pic1Url && pic2Url && pic3Url && pic4Url && pic5Url)}
          onClick={props.closemodal}
        >
          Cancel
        </Button>
        <div style={{ paddingLeft: "20px" }}>
          <Button
            variant="contained"
            color="primary"
            onClick={handleSave}
            style={{ marginTop: "0px" }}
            disabled={isSaving}
          >
            {isSaving ? <CircularProgress size={24} color="inherit" /> : "Save"}
          </Button>
        </div>
      </StandardDrawerFooter>
    </div>
  );
};

export default AddBioPsycho3;
